// src/components/ui/AdverseMediaTopNav.jsx
import React, { useEffect, useState } from "react";
import "./css/AdverseMediaTopNav.css";

function getScrollParent(el) {
  let p = el?.parentElement;
  while (p) {
    const style = window.getComputedStyle(p);
    const overflowY = style.overflowY;
    const canScroll =
      (overflowY === "auto" || overflowY === "scroll") &&
      p.scrollHeight > p.clientHeight;

    if (canScroll) return p;
    p = p.parentElement;
  }
  return document.scrollingElement || document.documentElement;
}

function getTopRelativeToParent(el, parent) {
  const isDocScroller =
    parent === document.scrollingElement || parent === document.documentElement;

  if (isDocScroller) {
    const rect = el.getBoundingClientRect();
    return rect.top + window.pageYOffset;
  }

  let top = 0;
  let node = el;
  while (node && node !== parent) {
    top += node.offsetTop || 0;
    node = node.offsetParent;
  }
  return top;
}

function short4(label) {
  const s = String(label || "")
    .replace(/[^a-z0-9]/gi, "")
    .toUpperCase();
  return (s || "----").slice(0, 4);
}

export default function AdverseMediaTopNav({
  items = [],
  activeId = "",
  offset = 0,
  showAfterPx = 100, // ✅ show only after user scrolls > 100px
  rightActions = null,
}) {
  const [shown, setShown] = useState(false);

  useEffect(() => {
    const onScroll = () => setShown(window.scrollY > showAfterPx);
    onScroll(); // init
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [showAfterPx]);

  function scrollToSection(sectionId) {
    if (!sectionId) return;

    const el = document.getElementById(sectionId);
    if (!el) return;

    const parent = getScrollParent(el);
    const isDocScroller =
      parent === document.scrollingElement ||
      parent === document.documentElement;

    const top = getTopRelativeToParent(el, parent) - (offset || 0);

    if (isDocScroller) window.scrollTo({ top, behavior: "smooth" });
    else parent.scrollTo({ top, behavior: "smooth" });
  }

  return (
    <div
      className={`amTopNavWrap ${shown ? "isShown" : ""}`}
      role="navigation"
      aria-label="KYC sections"
    >
      {rightActions ? <div className="amTopNavActions">{rightActions}</div> : null}
      <div className="amTopNavPill">
        {items.map((it) => {
          const isActive = it.id === activeId;
          return (
            <button
              key={it.id}
              type="button"
              className={"amTopNavItem" + (isActive ? " isActive" : "")}
              onClick={() => scrollToSection(it.id)}
              aria-current={isActive ? "page" : undefined}
            >
              <div className="amTopNavNo">{it.num}</div>
              <div className="amTopNavLabel">{short4(it.label)}</div>
              <div className="amTopNavDot" />
            </button>
          );
        })}
      </div>
    </div>
  );
}
